import { render, staticRenderFns } from "./information-again.vue?vue&type=template&id=90926e58&scoped=true&"
import script from "./information-again.vue?vue&type=script&lang=js&"
export * from "./information-again.vue?vue&type=script&lang=js&"
import style0 from "./information-again.vue?vue&type=style&index=0&id=90926e58&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90926e58",
  null
  
)

export default component.exports